type Func<A, B> = (a: A) => B;

export const pipe = <T extends Func<any, any>, R>(...fns: T[]) => (x: R) =>
  fns.reduce((v, f) => f(v), x);
